<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">

<g>
<path d="M20 40.81L23.2349 39.3113L20 38L20 39.405L20 40.81Z" stroke="black" stroke-width="4" stroke-linecap="round"/>
<path d="M23.2349 20L20 21.4987L23.2349 22.81L23.2349 21.405L23.2349 20Z" stroke="black" stroke-width="4" stroke-linecap="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M28.7641 30.0105C28.7641 27.0355 27.1159 24.4455 24.6829 23.1037V18.7493C29.3812 20.3345 32.7641 24.7774 32.7641 30.0105C32.7641 31.914 32.3166 33.7129 31.5209 35.3077L28.4464 32.2332C28.6532 31.5283 28.7641 30.7824 28.7641 30.0105ZM10.2432 24.7133C9.44757 26.3082 9 28.1071 9 30.0105C9 35.5789 12.8304 40.2526 18 41.5406V37.349C15.0724 36.1984 13 33.3465 13 30.0105C13 29.2387 13.1109 28.4928 13.3177 27.7878L10.2432 24.7133Z" fill="black"/>
</g>

<path fill-rule="evenodd" clip-rule="evenodd" d="M36.3962 41.4001C35.6692 42.5329 34.8074 43.571 33.8335 44.4918L48.5924 59.1131L50 60.5076L51.4076 59.1131L84.4076 26.4208L81.5924 23.5792L50 54.877L36.3962 41.4001Z" fill="black"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19 48.628C17.5913 48.3238 16.2496 47.8396 15 47.2009L15 75V77H17H83H85V75V25V23H83L35.9924 23C36.854 24.2215 37.554 25.5652 38.0611 27H81V73H19V48.628Z" fill="black"/>
</svg>


</template>
